import { render } from "./MedicalTeam.vue?vue&type=template&id=2b98d150"
import script from "./MedicalTeam.vue?vue&type=script&lang=js"
export * from "./MedicalTeam.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__